import axios from 'axios';

const strapiDirectUrl = import.meta.env.VITE_STRAPI_DIRECT_URL;
const strapiFeedbackApiKey = import.meta.env.VITE_STRAPI_FEEDBACK_KEY;

const instance = axios.create({
	baseURL: strapiDirectUrl,
	headers: {
		Authorization: `Bearer ${strapiFeedbackApiKey}`,
	},
});

export type FeedbackType = 'general';

export const submitFeedback = (
	type: FeedbackType,
	rating: number,
	feedback: string,
) => {
	const uuid = getFeedbackUserUUID();
	const deviceInfo = [
		document
			.querySelector('meta[name=application-platform]')
			?.getAttribute('content') ?? 'web',
		document
			.querySelector('meta[name=application-version]')
			?.getAttribute('content') ?? 'web',
		navigator.userAgent,
	].join(' ');

	// Use instance, but change the base URL to the Strapi URL
	// instance.defaults.baseURL = strapiDirectUrl;

	// Submit rating, feedback, uuid, type and deviceInfo
	return instance.post('/feedbacks', {
		data: {
			rating,
			feedback,
			uuid,
			type,
			deviceInfo,
		},
	});
};

export const getFeedbackUserUUID = () => {
	// get soortsafari-feedbackUserUUID from localStorage or set it to 16 random characters
	const feedbackUserUUID = localStorage.getItem(
		'soortsafari-feedbackUserUUID',
	);
	if (!feedbackUserUUID) {
		const newFeedbackUserUUID = Array.from(
			{ length: 16 },
			() => Math.random().toString(36)[2],
		).join('');
		localStorage.setItem(
			'soortsafari-feedbackUserUUID',
			newFeedbackUserUUID,
		);
		return newFeedbackUserUUID;
	}
	return feedbackUserUUID;
};
